import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { UtilService } from '../../services/util/util.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { faCalendar } from '@fortawesome/free-regular-svg-icons';

export const MONTH_YEAR_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MMMM, YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-select-date-option',
  templateUrl: './select-date-option.component.html',
  styleUrls: ['./select-date-option.component.css'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'th-TH' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MONTH_YEAR_FORMATS },
  ]
})
export class SelectDateOptionComponent {

  faCalendar = faCalendar;

  private _selectedOption: { type: string, value: string } | null = null;
  @Input()
  set selectedOption(value: { type: string, value: string } | null) {
    this._selectedOption = value;
    if (value?.type === 'date-range' && value.value) {
      const [start, end] = value.value.split(',');
      if (start && end) {
        this.selectedStartDate = new Date(start);
        this.selectedEndDate = new Date(end);
      }
    }
  }
  get selectedOption(): { type: string, value: string } | null {
    return this._selectedOption;
  }
  @Output() selectOption = new EventEmitter<{ type: string, value: string }>();

  dateOptions = [
    { id: '0', name: 'วันนี้', type: 'today' },
    { id: '1', name: 'เมื่อวาน', type: 'daypass' },
    { id: '7', name: '7 วันที่ผ่านมา', type: 'daypass' },
    { id: '30', name: '30 วันที่ผ่านมา', type: 'daypass' },
    { id: 'month', name: 'เดือนนี้', type: 'daypass' },
  ];

  maxDate = new Date();
  minDate = null;

  formMonthYear: FormGroup;
  formDateRange: FormGroup;

  selectedStartDate: Date | null = null;
  selectedEndDate: Date | null = null;

  constructor(
    private utilService: UtilService,
    private fb: FormBuilder,
  ) {
    this.formMonthYear = this.fb.group({
      localSelectedDate: [new Date()],
    });
    this.formDateRange = this.fb.group({
      startDate: [new Date()],
      endDate: [new Date()],
    });
  }

  onSelectDateOption(id: string) {
    this.selectOption.emit({
      type: 'daypass',
      value: id
    });
  }

  selectDateMonthYearChange(selectedDate: string) {
    const start = this.utilService.dayjs(selectedDate).startOf('month');
    this.selectOption.emit({
      type: 'month-year',
      value: start.format('YYYY-MM-DD')
    });
  }

  selectYearChange(selectedDate: string) {
    const start = this.utilService.dayjs(selectedDate).startOf('year');
    this.selectOption.emit({
      type: 'year',
      value: start.format('YYYY-MM-DD')
    });
  }

  chosenYearHandler(normalizedDate: any) {
    const ctrlValue = this.formMonthYear.get('localSelectedDate')?.value;
    ctrlValue?.setFullYear(normalizedDate.year());
    this.formMonthYear.get('localSelectedDate')?.setValue(ctrlValue);
    this.selectDateMonthYearChange(this.utilService.dayjs(this.formMonthYear.get('localSelectedDate')?.value).format('YYYY-MM-DD'));
  }

  chosenMonthHandler(normalizedDate: any, datepicker: MatDatepicker<any>) {
    const ctrlValue = this.formMonthYear.get('localSelectedDate')?.value;
    ctrlValue?.setMonth(normalizedDate.month());
    ctrlValue?.setFullYear(normalizedDate.year());
    this.formMonthYear.get('localSelectedDate')?.setValue(ctrlValue);
    this.selectDateMonthYearChange(this.utilService.dayjs(this.formMonthYear.get('localSelectedDate')?.value).format('YYYY-MM-DD'));
    datepicker.close();
  }


  // Function to format the selected date into a readable string (or placeholder)
  onDateSelected(date: Date | null): string {
    return date ? this.utilService.dayjs(date).format('D MMM YYYY') : '';
  }

  get dateRangeLabel(): string {
    if (this.selectedOption?.type !== 'date-range' || !this.selectedStartDate || !this.selectedEndDate) {
      return 'เลือกช่วงวันที่';
    }
    const start = this.onDateSelected(this.selectedStartDate);
    const end = this.onDateSelected(this.selectedEndDate);
    return start === end ? start : `${start} - ${end}`;
  }

  // Triggered when the date range changes
  onDateRangeSelected() {
    // You can add any logic here if needed after a new range is selected
    const startDate = this.utilService.dayjs(this.selectedStartDate).format('YYYY-MM-DD')
    const endDate = this.utilService.dayjs(this.selectedEndDate).format('YYYY-MM-DD')
    this.selectOption.emit({
      type: 'date-range',
      value: [startDate, endDate].toString()
    });
  }

  trackByFn(index: number) {
    return index;
  }
}
